import About from "./app_widgets/nfn_landing_page/About";

const NFNLandingPageComponent = () => {
  return (
    <>
      <About />
    </>
  );
};

export default NFNLandingPageComponent;
